export enum enumDetailedInfoPlacementEnum {
  shipmentDashboardTemplate,
  quoteDashboardTemplate,
  quoteTemplate,
  headerTemplate,
}
